import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";

import PaidInvoiceMatchTbl from "Components/Endcustomerpaid/Workflows/PaidInvoiceMatchTbl";

import { useEndCustomerPaid } from "Context/EndCustomerPaid";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export default function PaidInvoicesMatch({ onSearch }) {
  const {
    connectMatch,
    matchArticle,
    matchAccount,
    matchCreditToInvoice,
    removeMatch,
    matchSearch,
    selectedInvoice,
  } = useEndCustomerPaid();

  const { openError, openSuccess } = usePopupNotificationContext();
  const [loading, setLoading] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const handleRowSelection = (invoiceId) => {
    setSelectedRowId(invoiceId);
  };

  useEffect(() => {
    if (selectedInvoice) {
      setSelectedRowId(null);
    }
  }, [selectedInvoice]);

  const connectMatches = async () => {
    setLoading(true);

    const secondInvoice = selectedInvoice.InvoiceMatches?.find(
      (invoice) => invoice.AccountId === selectedRowId
    );

    const res = await connectMatch(
      selectedInvoice.Id,
      secondInvoice.InvoiceId,
      secondInvoice.AccountId
    );

    if (res.status !== 201) {
      openError("Ett fel har uppstått", 5000);
    }

    if (res.data.Status === "error") {
      openError(res.data.Message, 3000);
    }

    setLoading(false);
  };

  const handleOnRemove = async (invoice) => {
    setLoading(true);
    const res = await removeMatch(invoice.PaidInvoiceId, invoice.AccountId);
    setLoading(false);
    return res;
  };

  return (
    <>
      <Grid
        container
        item
        maxHeight="1500px"
        sx={{ overflowX: "hidden", overflowY: "auto" }}
        textAlign="center"
      >
        <Grid item xs={12}>
          <PaidInvoiceMatchTbl
            paidInvoicesMatch={
              selectedInvoice ? selectedInvoice.InvoiceMatches : []
            }
            selectedRowId={selectedRowId}
            connectMatchesReq={connectMatches}
            matchArticle={matchArticle}
            matchAccount={matchAccount}
            matchCreditToInvoice={matchCreditToInvoice}
            onSearch={onSearch}
            handleRowSelection={handleRowSelection}
            handleOnRemove={handleOnRemove}
            loading={loading}
          />
        </Grid>
      </Grid>
    </>
  );
}
